import { REGEX } from './regex';

export const requiredValidationRule = {
  required: {
    value: true,
    message: 'admin-form-errors.required-field',
  },
  validate: (value: string) => {
    if (typeof value !== 'string') return true;
    else
      return value?.trim()?.length > 0
        ? true
        : 'admin-form-errors.required-field';
  },
} as const;

export const phoneNumberValidationRule = {
  pattern: {
    value: REGEX.PHONE,
    message: 'admin-form-errors.provide-correct-phone-number',
  },
};

export const emailValidationRule = {
  pattern: {
    value: REGEX.EMAIL,
    message: 'admin-form-errors.provide-correct-email',
  },
};

export const emailBlacklistValidationRule = {
  pattern: {
    value: REGEX.BLACKLIST_EMAIL,
    message: 'admin-form-errors.blacklisted-email',
  },
};
